var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgFire(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 18,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M10.581 1.83a.9.9 0 0 1 .574.467c.436.87.76 1.399 1.087 1.827.33.434.68.789 1.213 1.321A6.283 6.283 0 0 1 15.3 9.9 6.3 6.3 0 1 1 4.545 5.445a.9.9 0 0 1 1.537.636c0 1.008.063 1.776.358 2.389.162.337.414.666.85.96.104-.955.295-2.118.553-3.222.202-.87.455-1.737.755-2.46.15-.363.32-.708.513-1.005.188-.29.429-.584.74-.792a.9.9 0 0 1 .73-.121Zm.328 11.779a2.7 2.7 0 0 1-4.609-1.91s.791.45 2.25.45c0-.9.45-3.6 1.125-4.05.45.9.707 1.164 1.234 1.692.528.527.791 1.218.791 1.909 0 .69-.263 1.382-.79 1.909Z",
    fill: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFire);
export default __webpack_public_path__ + "static/media/fire.88c9fe24622ff42970d01889a9e584b2.svg";
export { ForwardRef as ReactComponent };